import { render, staticRenderFns } from "./LanguagesChangeModal.vue?vue&type=template&id=ebf7364a&scoped=true&"
import script from "./LanguagesChangeModal.vue?vue&type=script&lang=js&"
export * from "./LanguagesChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesChangeModal.vue?vue&type=style&index=0&id=ebf7364a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf7364a",
  null
  
)

export default component.exports